export const containsActiveSubscription = <
  T extends { endWeek?: string; status: string },
>(
  subscriptions?: T[],
): boolean => {
  return !!subscriptions?.some((subscription) => {
    const isRecurring = !subscription.endWeek;
    return subscription.status === 'ACTIVE' && isRecurring;
  });
};
